angular.module('picmonicng').factory('OutOfMarketModal', [
  '$modal',
  'UserService',
  'MarketOptionsConfig',
  function ($modal, UserService, MarketOptionsConfig) {
    return {
      check: function (marketId) {
        var self = this;

        if (UserService.user.user_id && UserService.user.lead && UserService.user.lead !== marketId) {
          var packageMarket = MarketOptionsConfig.getMarketById(marketId);
          if (packageMarket && packageMarket.is_pseudo) {
            return;
          }

          var market = MarketOptionsConfig.getMarketById(UserService.user.lead);
          if (market.id && !market.is_beta && market.pricing_url !== '/pricing') {
            self.show(packageMarket);
          }
        }
      },
      show: function (market) {
        $modal.open({
          templateUrl: '/templates/app/factories/out-of-market-modal/out-of-market-modal.html',
          windowClass: 'pls-modal-abyss',
          backdrop: 'static',
          controller: [
            '$scope',
            '$modalInstance',
            'UserService',
            'MarketOptionsConfig',
            function ($scope, $modalInstance, UserService, MarketOptionsConfig) {
              $scope.UserService = UserService;
              $scope.MarketOptionsConfig = MarketOptionsConfig;
              $scope.market = market;
            },
          ],
        });
      },
    };
  },
]);
